import { render, staticRenderFns } from "./GridPosts.vue?vue&type=template&id=69227efa&scoped=true&"
import script from "./GridPosts.vue?vue&type=script&lang=js&"
export * from "./GridPosts.vue?vue&type=script&lang=js&"
import style0 from "./GridPosts.vue?vue&type=style&index=0&id=69227efa&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69227efa",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/app/components/Button.vue').default})
